import * as d3 from 'd3'
import {
  VTooltip,
} from 'v-tooltip'
import MetodosGlobais from '@/utils/MetodosGlobais'
import Legenda from './Legenda'

export default {
  name: 'MapMixin',
  mixins: [Legenda],
  directives: {
    tooltip: VTooltip,
  },
  data () {
    return {
      hover: false,
      svg: d3.select('svg'),
      ultimoClick: null,
      tooltipOptions: {
        content: 'Região',
        placement: 'right',
      },
      nome: [],
    }
  },
  props: {
    habilitarAnimacaoClique: {
      type: Boolean,
      default: true,
    },
    habilitarLegenda: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    definirLegenda (colors, labels, element = 'legenda') {
      this.drawLegenda(d3.select('#' + element), colors, labels)
    },
    hideTooltip () {
      this.tooltipOptions = {}
      Object.freeze(this.tooltipOptions)
    },
    changeTooltip (evento) {
      let id = evento.target.id
      let idNum = MetodosGlobais.idSvgToNumeric(id)
      if (this.nomes[idNum] && !Object.isFrozen(this.tooltipOptions)) {
        this.tooltipOptions.content = this.nomes[idNum].nome
      }
    },
    pintarRegiao (id, rgb) {
      document.getElementById(id).style.fill = rgb
    },
    getCorRegia (id) {
      return document.getElementById(id).style.fill
    },
    selecionarMacroRegiao ({
      id,
      rgb,
    }) {
      document.getElementById(id).style.fill = rgb
    },
    limparClick (id, limparCor) {
      if (id) {
        let element = document.getElementById(id)
        let cor = element.style.fill
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            element.removeAttribute('style')
            if (!limparCor) {
              element.style.fill = cor
            }
            element.classList.remove('ativado')
          })
        })
      }
    },
    mouseHover (boo) {
      this.hover = boo
    },
    emulateClick (id) {
      this.__transformPath(this.prefix + id)
    },
    async clicarRegiao (event, prefixo) {
      if (this.habilitarAnimacaoClique) {
        let id = event.currentTarget.id
        this.__transformPath(prefixo + id)
        this.$emit('regiaoClicada', id)
      }
    },
    limparClickTodas (limparCor) {
      for (var i = 1; i <= 32; i++) {
        var element = document.getElementById('DER-' + i)
        let cor = element.style.fill
        element.removeAttribute('style')
        if (!limparCor) {
          element.style.fill = cor
        }
        element.classList.remove('ativado')
      }
    },
    // Os métodos abaixo trabalham com remoção e adição de classes ao invés de mudança direta no style para não dar override no css, principalmente do active e hover do path
    diminuirOpacidade (id) {
      let x = document.getElementById(id)
      if (x.classList.contains('opNormal')) {
        x.classList.remove('opNormal')
        x.classList.add('opClaro')
      } else if (!x.classList.contains('opClaro')) {
        x.classList.add('opClaro')
      }
    },
    aumentarOpacidade (id) {
      let x = document.getElementById(id)
      if (x.classList.contains('opClaro')) {
        x.classList.remove('opClaro')
        x.classList.add('opNormal')
      } else if (!x.classList.contains('opNormal')) {
        x.classList.add('opNormal')
      }
    },
    diminuirOpacidadeTodas () {
      for (let i = 1; i <= 32; i++) {
        this.diminuirOpacidade(MetodosGlobais.numericToIdSvg(i))
      }
    },
    aumentarOpacidadeTodas () {
      for (let i = 1; i <= 32; i++) {
        this.aumentarOpacidade(MetodosGlobais.numericToIdSvg(i))
      }
    },
    __transformPath (id, scale = 'scale(1.1)') {
      d3.select(id).raise()
      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => {
          d3.select(id).style('transform', scale)
        })
      })
    },
  },
}
